import { ShippingProfilesApiClient } from '@fourthwall/services/dist/ShippingProfilesApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useSaveShippingProfileMutation = createMutationHook(
  ShippingProfilesApiClient.saveShippingProfile,
  {
    mutationKey: ['saveShippingProfile'],
  },
)
